export const TEMPLATE_NAME = "TEMPLATE_NAME";
export const INITIAL_VALUES = "INITIAL_VALUES";
